const Footer = () => {
  return (
    <footer className="px-4 md:px-2 py-4 bg-grey-08 text-center z-20">
      <p className="b3 text-white">
        Copyright © 2026 Computechoice.com. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
